import Dinero from 'dinero.js'
import { toast } from 'react-toastify'
import { Button, Wrapper } from '@farewill/ui'
import { QuoteResponseDataProbate } from 'lib/types'

const handleCopyClick = (text: string) => {
  navigator.clipboard.writeText(text)

  toast('Copied to clipboard.', {
    toastId: 'probate-only-copied-to-clipboard',
  })
}

const ProbateOnlyCopyToClipboard = ({
  quote,
  calculatedPrices,
}: {
  quote: QuoteResponseDataProbate
  calculatedPrices: {
    totalInPence: number
    amountBeforeVatAndDiscountInPence: number
    vatInPence: number
    disbursementsPriceInPence: number
  }
}) => {
  const { discountAmountInPence } = quote.attributes.grantOnly

  const fees = [] as string[]

  const feeExcVat = `Fee exc. VAT: ${Dinero({
    amount: calculatedPrices.amountBeforeVatAndDiscountInPence,
  }).toFormat('$0,0.00')}`
  fees.push(feeExcVat)

  const twentyPercentVat = `20% VAT: ${Dinero({
    amount: calculatedPrices.vatInPence,
  }).toFormat('$0,0.00')}`
  fees.push(twentyPercentVat)

  if (discountAmountInPence > 0) {
    const voucher = `voucher: ${Dinero({
      amount: discountAmountInPence ? -discountAmountInPence : 0,
    }).toFormat('$0,0.00')}`
    fees.push(voucher)
  }

  const disbursements = `disbursements: ${Dinero({
    amount: calculatedPrices.disbursementsPriceInPence,
  }).toFormat('$0,0.00')}`
  fees.push(disbursements)

  const totalPrice = `\nTotal: ${Dinero({
    amount: calculatedPrices.totalInPence,
  }).toFormat('$0,0.00')}`
  fees.push(totalPrice)

  return (
    <Wrapper margin={['L', 0, 0]} centered>
      <Button.Primary
        onClick={() => {
          handleCopyClick(fees.join('\n'))
        }}
      >
        Copy quote to clipboard
      </Button.Primary>
    </Wrapper>
  )
}

export default ProbateOnlyCopyToClipboard
